import { useMutation } from '@apollo/client';

import { CURRENT_EVENT } from '../../event/graphql/query/currentEventQuery.graphql';
import { LEAVE_BEDROOM } from '../graphql/mutation/leaveBedroomMutation.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';

export const useLeaveBedroomMutation = () => {
  const [mutate] = useMutation(LEAVE_BEDROOM);

  const leaveBedroom = (bedroomId: string, eventId: string) => {
    mutate({
      variables: {
        bedroomId,
        eventId,
      },
      refetchQueries: [EVENT_BEDROOMS, CURRENT_EVENT],
    });
  };

  return { leaveBedroom };
};
